import { FC } from "react";
import { useLocation } from "react-router-dom";
import { useFlag } from "@unleash/proxy-client-react";
import { NavItem } from "../nav-item/NavItem";
import CommitmentsSvgIcon from "../../../../assets/images/icons/commitments/CommitmentsSvgIcon";
import { useGetUsersMeOrganisationsCurrentProviderOrganisationsQuery } from "../../../../services/cloudchipr.api";
import { useAppSelector } from "../../../../store/hooks";
import { navigationCollapsedSelector } from "../../../../store/common/selectors/navigation/navigationCollapsedSelector";
import AWSSvgIcon from "../../../../assets/images/logos/providers/AWSSvgIcon";
import UtilizationAndCoverageSvgIcon from "../../../../assets/images/icons/commitments/UtilizationAndCoverageSvgIcon";
import CommitmentsRecommendationsSvgIcon from "../../../../assets/images/icons/commitments/CommitmentsRecommendationsSvgIcon";

export const CommitmentsNavigationV2: FC = () => {
  const { data } = useGetUsersMeOrganisationsCurrentProviderOrganisationsQuery(
    undefined,
    {
      selectFromResult: ({ data }) => {
        return {
          data: data?.filter((org) => org.cloud_provider === "aws"),
        };
      },
    },
  );
  const navigationCollapsed = useAppSelector(navigationCollapsedSelector);
  const enableSavingsPlanRecommendation = useFlag(
    "EnableSavingsPlanRecommendation",
  );

  const location = useLocation();
  const selected = location.pathname.startsWith("/commitments");
  const disabled = !data?.length;

  if (!data) {
    return null;
  }

  if ((data?.length ?? 0) < 2) {
    const firstItem = data.at(0);
    const orgId = firstItem?.organization_id ?? "";
    return (
      <NavItem
        primary="Commitments"
        icon={CommitmentsSvgIcon}
        selected={selected}
        navCollapsed={navigationCollapsed}
        disabled={disabled}
        tooltipTitle={
          disabled
            ? "Currently, commitments are available only for AWS."
            : undefined
        }
      >
        <NavItem
          nested
          icon={UtilizationAndCoverageSvgIcon}
          primary="Utilization & Coverage"
          to={`/commitments/utilization-and-coverage/${orgId}`}
        />
        <NavItem
          nested
          icon={CommitmentsRecommendationsSvgIcon}
          primary="Recommendations"
          to={`/commitments/recommendations/${orgId}`}
          disabled={!enableSavingsPlanRecommendation}
        />
      </NavItem>
    );
  }

  return (
    <NavItem
      primary="Commitments"
      icon={CommitmentsSvgIcon}
      navCollapsed={navigationCollapsed}
      selected={selected}
    >
      {data?.map((org) => (
        <NavItem
          nested
          key={org.organization_id}
          primary={org.organization_id}
          icon={AWSSvgIcon}
          selected={location.pathname.startsWith(
            `/commitments/utilization-and-coverage/${org.organization_id}`,
          )}
        >
          <NavItem
            nested
            icon={UtilizationAndCoverageSvgIcon}
            primary="Utilization & Coverage"
            to={`/commitments/utilization-and-coverage/${org.organization_id}`}
            listItemButtonSx={{
              pl: 5,
            }}
          />
          <NavItem
            nested
            icon={CommitmentsRecommendationsSvgIcon}
            primary="Recommendations"
            to={`/commitments/recommendations/${org.organization_id}`}
            disabled={!enableSavingsPlanRecommendation}
            listItemButtonSx={{
              pl: 5,
            }}
          />
        </NavItem>
      ))}
    </NavItem>
  );
};
